// extracted by mini-css-extract-plugin
export var bulletsList = "AboutSection-module--bulletsList--I9bbF";
export var container = "AboutSection-module--container--iga+h";
export var ctas = "#226355";
export var grayBackground = "#f6f8fb";
export var link = "AboutSection-module--link---XULS";
export var listContainer = "AboutSection-module--listContainer--3p2l-";
export var listItem = "AboutSection-module--listItem--vA92q";
export var textContainer = "AboutSection-module--textContainer--dTQiN";
export var title = "AboutSection-module--title--5-GUa";